import gb from 'flag-icons/flags/4x3/gb.svg?url'
import us from 'flag-icons/flags/4x3/us.svg?url'
import fr from 'flag-icons/flags/4x3/fr.svg?url'
import it from 'flag-icons/flags/4x3/it.svg?url'
import pl from 'flag-icons/flags/4x3/pl.svg?url'
import es from 'flag-icons/flags/4x3/es.svg?url'
import pt from 'flag-icons/flags/4x3/pt.svg?url'
import de from 'flag-icons/flags/4x3/de.svg?url'
import cz from 'flag-icons/flags/4x3/cz.svg?url'
import sk from 'flag-icons/flags/4x3/sk.svg?url'
import si from 'flag-icons/flags/4x3/si.svg?url'
import tr from 'flag-icons/flags/4x3/tr.svg?url'
import nl from 'flag-icons/flags/4x3/nl.svg?url'
import hu from 'flag-icons/flags/4x3/hu.svg?url'
import ro from 'flag-icons/flags/4x3/ro.svg?url'

export const FLAG_ICONS: Record<string, string> = {
  gb,
  us,
  fr,
  it,
  pl,
  es,
  pt,
  de,
  cz,
  sk,
  si,
  tr,
  nl,
  hu,
  ro
}

export const COUNTRY_LABELS: Record<string, string> = {
  en: 'English',
  us: 'American English',
  fr: 'Français',
  it: 'Italiano',
  pl: 'Polski',
  es: 'Español',
  pt: 'Português',
  de: 'Deutsch',
  cs: 'Čeština',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  tr: 'Türkçe',
  nl: 'Nederlands',
  hu: 'Magyar',
  ro: 'Română'
}
